
window.site = (window.site || {});

/**
 * Init script
 * @class Site
 * @static
*/
site.AdminForms = (function AdminForms() {

  'use strict';

  /**
   * Has the class been initialized?
   * @private
   */
  let inited = false;

  /**
   * Initializes the class.
   * @public
   */
  const init = function () {

    // Abort if already initialized
    if (inited) {
      return false;
    }

    inited = true;

    if (document.querySelector('[data-swal-msg]')) {
      const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true
      });

      Toast.fire({
        icon: document.querySelector('[data-swal-msg]').getAttribute('data-type'),
        title: document.querySelector('[data-swal-msg]').textContent
      })
    }

    // Delete Row
    [].slice.call(document.querySelectorAll('[data-zone]')).forEach(function(elem) {
      elem.addEventListener('click', function(e) {

        if (!e.target.getAttribute('data-delete')) {
          return;
        }

        Swal.fire({
          title: 'Supprimer',
          text: "Voulez-vous vraiment supprimer ce block?",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#212C47',
          cancelButtonColor: '#D31C1C',
          confirmButtonText: 'Oui',
          cancelButtonText: 'Non',
        }).then((result) => {
          if (result.isConfirmed) {
            var id = e.target.getAttribute('data-delete');
            var zone = elem.querySelector('[data-row="'+id+'"]');

            zone.innerHTML = '';
            zone.classList.remove('is-active');
            zone.setAttribute('data-row', 'deleted')

            zone.closest('[data-zone]').querySelector('[data-add-row]').classList.remove('is-max');
          }
        })
      });
    });

    // Duplicate Row || Add new Row
    [].slice.call(document.querySelectorAll('[data-add-row]')).forEach(function(elem) {
      elem.addEventListener('click', function(e) {
        e.preventDefault();

        if (elem.classList.contains('is-max')) {
          return;
        }

        var id = elem.getAttribute('data-add-row');
        var zone = document.querySelector('#' + id);
        var maxItems = parseInt(elem.getAttribute('data-max'));
        var totalItems = zone.querySelectorAll('.is-active').length;

        if (totalItems >= maxItems) {
          elem.classList.add('is-max');
          return;
        }

        var duplicata = zone.querySelector('[data-row="new"]').cloneNode(true);
        duplicata.classList.add('is-active');
        var temp = document.createElement("div");
        temp.appendChild(duplicata);

        var duplicataString = temp.innerHTML.replaceAll('data-name', 'name').replaceAll('data-required', 'required').replaceAll('new', 'new' + (totalItems + 1));
        var temp2 = document.createElement("div");
        temp2.innerHTML = duplicataString.trim();

        console.log(maxItems, totalItems, temp2.firstChild);

        elem.before(temp2.firstChild);

        if (totalItems == (maxItems - 1)) {
          elem.classList.add('is-max');
        }
      });
    });

    // Add Label helper
    [].slice.call(document.querySelectorAll('.form-input')).forEach(function(elem) {
      var label = elem.querySelector('[placeholder]').getAttribute('placeholder');
      var labelElem = document.createElement('p');
      labelElem.innerHTML = label;
      labelElem.classList.add('form-label');
      elem.querySelector('[placeholder]').after(labelElem);
    });

    var checkInputFillState = function() {
      // Input state check
      [].slice.call(document.querySelectorAll('.form-input')).forEach(function(elem) {
        var input = elem.querySelector('[placeholder]');

        if (input.value) {
          input.classList.add('is-filled');
        } else {
          input.classList.remove('is-filled');
        }
      });
    };

    [].slice.call(document.querySelectorAll('.form-input')).forEach(function(elem) {
      var input = elem.querySelector('[placeholder]');

      input.addEventListener('change', function(e) {
        checkInputFillState();
      });

      input.addEventListener('keyup', function(e) {
        checkInputFillState();
      });
    });

    checkInputFillState();

    // Simple Clone Puce
    [].slice.call(document.querySelectorAll('[data-clone]')).forEach(function(elem) {
      elem.addEventListener('click', function(e) {
        e.preventDefault();
        var id = elem.getAttribute('data-clone');

        var duplicata = document.querySelector('#' + id).cloneNode(true);
        duplicata.classList.remove('is-placeholder-data');
        var temp = document.createElement("div");
        temp.appendChild(duplicata);

        var duplicataString = temp.innerHTML.replaceAll('data-name', 'name').replaceAll('data-required', 'required').replaceAll('new', 'new' + new Date().valueOf());
        var temp2 = document.createElement("div");
        temp2.innerHTML = duplicataString.trim();

        elem.before(temp2.firstChild);
      });
    });

    // Handle File change
    [].slice.call(document.querySelectorAll('.custom-file-input.emplois-photo')).forEach(function(elem) {
      elem.addEventListener('change', function(e) {
        elem.setAttribute('name', elem.getAttribute('data-name'));

        if (elem.getAttribute('data-delete-if-changed')) {
          var id = elem.getAttribute('data-delete-if-changed');
          document.querySelector('[data-delete-ref="' + id + '"]').setAttribute('name', 'ignored');
        }
      });
    });

    // Delete Emploi
    if (document.querySelector('.delete')) {
      document.querySelector('.delete').addEventListener('click', function(e) {
        e.preventDefault();

        Swal.fire({
          title: 'Supprimer',
          text: "Voulez-vous vraiment supprimer cet emploi?",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#212C47',
          cancelButtonColor: '#D31C1C',
          confirmButtonText: 'Oui',
          cancelButtonText: 'Non',
        }).then((result) => {
          if (result.isConfirmed) {
            document.querySelector('.admin-form-delete-emploi').submit();
          }
        });
      });
    };

    // Reveal zone
    [].slice.call(document.querySelectorAll('[data-reveal]')).forEach(function(elem) {
      elem.addEventListener('click', function(e) {
        e.preventDefault();

        var id = elem.getAttribute('data-reveal');
        document.querySelector('#' + id).classList.toggle('is-active');

        if (document.querySelector('#' + id).classList.contains('is-active')) {
          elem.textContent = 'Cacher';
        } else {
          elem.textContent = 'Afficher';
        }
      });
    });

    // Croppable
    [].slice.call(document.querySelectorAll('[data-crop]')).forEach(function(elem) {
      elem.addEventListener('click', function(e) {
        e.preventDefault();

        var id = elem.getAttribute('data-crop');
        var zone = document.querySelector('[data-crop-id="' + id + '"]');
        zone.classList.add('is-active');

        setTimeout(function() {
          var el = zone.querySelector('[data-croppable]');
          var image = zone.querySelector('img');

          var cropBtn = zone.querySelector('[data-get-crop]');
          var cancelBtn = zone.querySelector('[data-cancel-crop]');

          var CropperEl = new Cropper(image, {
            aspectRatio: parseInt(el.getAttribute('data-ratio-in')) / parseInt(el.getAttribute('data-ratio-out')),
            rotatable: false,
            minCropBoxWidth: parseInt(el.getAttribute('data-width')),
            minCropBoxHeight: parseInt(el.getAttribute('data-height')),
          });

          var initialRatio = false;
          image.addEventListener('zoom', (event) => {
            // Zoom in
            if (event.detail.ratio > event.detail.oldRatio) {
              // event.preventDefault(); // Prevent zoom in

              if (!initialRatio) {
                initialRatio = event.detail.ratio;
              }
            }

            // Zoom out
            if (!initialRatio || event.detail.ratio  < initialRatio) {
              event.preventDefault(); // Prevent zoom out
            }
          });

          // Crop action
          cropBtn.addEventListener('click', function(e) {

            var blob = CropperEl.getCroppedCanvas({
              width: parseInt(el.getAttribute('data-width')),
              height: parseInt(el.getAttribute('data-height')),
              minWidth: parseInt(el.getAttribute('data-width')),
              minHeight: parseInt(el.getAttribute('data-height')),
              maxWidth: parseInt(el.getAttribute('data-width')),
              maxHeight: parseInt(el.getAttribute('data-height')),
              fillColor: '#fff',
              imageSmoothingEnabled: false,
              imageSmoothingQuality: 'high'
            }).toDataURL();

            var fieldData = document.querySelector('[data-crop-result-data="' + id + '"]');
            fieldData.value = blob;
            fieldData.setAttribute('name', fieldData.getAttribute('data-name'));

            var fieldName = document.querySelector('[data-crop-result-name="' + id + '"]');
            fieldName.setAttribute('name', fieldName.getAttribute('data-name'));

            document.querySelector('[data-crop-result-preview="' + id + '"]').setAttribute('src', blob);

            zone.classList.remove('is-active');

            CropperEl.destroy();
          });

          // Cancel action
          cancelBtn.addEventListener('click', function(e) {
            zone.classList.remove('is-active');
            CropperEl.reset();
          });
        }, 1);
      });
    });

    // Crop Preview job
    setInterval(function() {
      [].slice.call(document.querySelectorAll('[data-crop-result-preview]')).forEach(function(elem) {
        var id = elem.getAttribute('data-crop-result-preview');
        var fileName = elem.getAttribute('data-crop-result-filename');

        if (window.localStorage.getItem('craft-crop-img-' + id)) {
          setTimeout(function() {
            elem.setAttribute('src', '/assets/entreprises/' + fileName + '?tt=' + new Date().valueOf());

            const Toast = Swal.mixin({
              toast: true,
              position: 'top-end',
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true
            });

            Toast.fire({
              icon: 'success',
              title: 'Image recadré avec succès.'
            })
          }, 3555);
          window.localStorage.removeItem('craft-crop-img-' + id);
        }
      });
    }, 4000);

    // Max Length counter
    if (document.querySelector('.maxlength-count')) {
      [].slice.call(document.querySelectorAll('.maxlength-count')).forEach(function(elem) {
        var id = elem.getAttribute('data-maxlength-id');
        var textElem = document.querySelector('#' + id);

        var max = parseInt(elem.getAttribute('data-maxlength'));
        var current = textElem.value.length;

        elem.innerHTML = max - current;

        textElem.addEventListener('keyup', function(e) {
          e.preventDefault();

          var max = parseInt(elem.getAttribute('data-maxlength'));
          var current = textElem.value.length;

          elem.innerHTML = max - current;
        });
      });
    }

    // ReOrdering of Photos
    function enableDragSort(listClass) {
      const sortableLists = document.getElementsByClassName(listClass);
      Array.prototype.map.call(sortableLists, (list) => {enableDragList(list)});
    }

    function enableDragList(list) {
      Array.prototype.map.call(list.querySelectorAll('[drag-item]'), (item) => {enableDragItem(item)});
    }

    function enableDragItem(item) {
      item.setAttribute('draggable', true);
      item.ondrag = handleDrag;
      item.ondragend = handleDrop;
    }

    function handleDrag(item) {
      const selectedItem = item.target,
            list = selectedItem.parentNode,
            x = event.clientX,
            y = event.clientY;

      selectedItem.classList.add('drag-sort-active');
      let swapItem = document.elementFromPoint(x, y) === null ? selectedItem : document.elementFromPoint(x, y);

      if (list === swapItem.parentNode) {
        swapItem = swapItem !== selectedItem.nextSibling ? swapItem : swapItem.nextSibling;
        list.insertBefore(selectedItem, swapItem);
      }
    }

    function handleDrop(item) {
      item.target.classList.remove('drag-sort-active');
    }

    (()=> {enableDragSort('drag-sort-enable')})();

    return true;

  };

  // Expose public methods & properties
  return {
    init: init,
  };

}().init());
